import { C30IconCTASimplifiedProps } from './C30IconCTASimplified.types';
import { C30IconCTASimplifiedCardProps } from './C30IconCTASimplifiedCard';
import { IconCtaSimplifiedCardProps, IconCtaSimplifiedProps } from '@ahc-digital/component-library';
import { ICON_CTA_SIMPLIFIED_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

export function CreateIconCTASimplifiedCard(
  props?: C30IconCTASimplifiedCardProps
): IconCtaSimplifiedCardProps {
  type t = IconCtaSimplifiedCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderLink } = useConditionalRendering();
  const ctaStyle = getDroplink<t['ctaStyle']>(params?.CTAStyle, 'button');

  return {
    icon: fields?.Icon?.fields?.Value?.value as t['icon'],
    ctaStyle,
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
  };
}

export function CreateIconCTASimplified(props?: C30IconCTASimplifiedProps): IconCtaSimplifiedProps {
  type t = IconCtaSimplifiedProps;
  const { rendering, params, fields } = props || {};

  const { renderRichText, renderText } = useConditionalRendering();
  const headlineTag = getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h2');
  const numberOfColumns = getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '2');
  const mobileBehavior = getDroplink<t['mobileBehavior']>(params?.MobileBehavior, 'stacked');

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    headlineTag,
    numberOfColumns,
    mobileBehavior,
    iconCtas: rendering ? (
      <Placeholder name={ICON_CTA_SIMPLIFIED_CARDS} rendering={rendering} />
    ) : (
      <></>
    ),
  };
}
